import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Conversation } from './types/Conversation';
import { APIV2_URL } from './constants';

interface Payload {
  listingId: number;
  startDate: string;
  endDate: string;
  messageText: string;
  instantBooking?: boolean;
  adProvider?: string;
  adClickID?: string;
}

export default (makeCall: MakeCall) => (data: Payload) =>
  makeCall<Conversation>('POST', `${APIV2_URL}/conversation`, { data });
